import { Component, Input, OnInit } from '@angular/core';
import { ReportRegistryService } from 'src/app/services/report/report-registry.service';

@Component({
  selector: 'app-report-toggle-button',
  templateUrl: './report-toggle-button.component.html',
  styleUrls: ['./report-toggle-button.component.css']
})
export class ReportToggleButtonComponent implements OnInit {
  is_selected: boolean = false;

  @Input() report_name: string = '';

  constructor(
    private report_registry: ReportRegistryService,
  ) { }

  ngOnInit() {
    this.report_registry.registerReport(this.report_name);
    this.report_registry.is_loaded.subscribe(is_loaded => {
      if(is_loaded) {
        this.is_selected = this.report_registry.checkIfReportIsSelected(this.report_name);
      }
    })
  }

  takeAction() {
    if (!this.is_selected) {
      this.report_registry.addReport(this.report_name);
    } else {
      this.report_registry.removeReport(this.report_name);
    }

    this.is_selected = !this.is_selected;
  }
}
